import type { PropsWithChildren } from "react";

import type { WithStylexArray } from "../../../types/withStyleXArray.types";
import { Text } from "../../_base/_core/Text/Text";

type AuthErrorProps = WithStylexArray<PropsWithChildren>;

export const AuthError = ({ styleXArray, children }: AuthErrorProps) => (
  <Text as={"p"} type={"detail"} size={"xl"} styleXArray={styleXArray}>
    {children}
  </Text>
);
